import * as types from '../../actions/actionTypes';
import initialState from '../initialState';


export default function submitButtonReducer(state = initialState.showSubmitButtonSpinner, action) {
    switch (action.type) {
        case types.SHOW_SUBMIT_BUTTON_SPINNER:
            return true;
        case types.HIDE_SUBMIT_BUTTON_SPINNER:
            return false;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/submit/submitButtonReduser.js